export default __webpack_public_path__ + "static/media/green-light.381cfd82.svg";